import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import ConceptosErroneos from "../../components/Form/Fields/ConceptosErroneos";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import TemaClase from "../../components/Form/Fields/TemaClase";
import ConcepcionesErroneasCardImg from "../../components/UmmIApps/Cards/ConcepcionesErroneasCardImg.png";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import CurriculumTabs from "../../components/CurriculumTabs/CurriculumTabs";
import { isSendButtonDisabled } from "../../config/sendButtonRules";

const ConcepcionesErroneasPage = () => {
  const {
    nivelId,
    materiaId,
    promptData,
    handleBack,
    toggleCamposAvanzados,
    mostrarCamposAvanzados,
    setTextoInicial,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
    handleNivelTPChange,
    handleAsignaturaTPChangeLocal,
    clearTP,
    setPromptData,
    nivelTPId,
    asignaturaTPId,
  } = useActividadesContext();


  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled =  isSendButtonDisabled("concepciones_erroneas", { promptData });
  const colorIconBack = "#BA4534";

  useEffect(() => {
    const init = {
      tema: "",
      conceptos_errados: "",
      caracterizacion: "",
      condiciones_contexto: "",
      adaptaciones_curriculares: "",
    };
    handleInitialPromptData(init, "concepciones_erroneas");
    setTextoInicial(
      "Te presentamos diferentes opciones de concepciones erróneas comunes relacionadas al contenido que puedes trabajar con tus estudiantes. Puedes elegir y editar cualquiera de las opciones según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={ConcepcionesErroneasCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #E3B5AE 100%, #C86A5D 100%)"
        }
        titleColor="#BA4534"
        title="Concepciones erróneas comunes"
        description="Detecta las concepciones equivocadas más frecuentes en tus estudiantes considerando su edad y contexto. Después, ajusta tu enseñanza con actividades activas para prevenir esas confusiones."
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
       <Grid container spacing={2}>
          <Grid item xs={12}>
            
              <CurriculumTabs
                nivelId={nivelId}
                materiaId={materiaId}
                nivelTPId={nivelTPId}
                asignaturaTPId={asignaturaTPId}
                handleNivelChange={handleNivelChange}
                handleNivelTPChange={handleNivelTPChange}
                handleAsignaturaChangeLocal={handleAsignaturaChangeLocal}
                handleAsignaturaTPChangeLocal={handleAsignaturaTPChangeLocal}
                clearTP={clearTP}
                promptData={promptData}
                setPromptData={setPromptData}
              />
            
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          display={"flex"}
          flexDirection={"row"}
          sx={{ mt: 3 }}
        >
          <TemaClase />
        </Grid>

        <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
          <Button
            variant="text"
            sx={{ color: "#336B87" }}
            onClick={toggleCamposAvanzados}
            endIcon={
              mostrarCamposAvanzados ? <ExpandLessIcon /> : <ExpandMoreIcon />
            }
          >
            {mostrarCamposAvanzados
              ? "Ocultar opciones avanzadas"
              : "Mostrar opciones avanzadas (opcional)"}
          </Button>
        </Grid>

        {/* Campos avanzados */}
        {mostrarCamposAvanzados && (
          <>
            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <ConceptosErroneos
                promptData={promptData}
                setPromptData={setPromptData}
              />
            </Grid>

            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <CondicionesContexto />
            </Grid>

            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <Caracterizacion />
            </Grid>

            <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
              <AdaptacionesCurriculares />
            </Grid>
          </>
        )}
      </UmmiaAppsLayout>
    </>
  );
};

export default ConcepcionesErroneasPage;
